import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { SaleRefundPanel } from '@/components/sales/SaleRefundPanel';

const Je = ({ j }) => (
  <div className="rounded-lg border p-2 text-xs" data-testid={`sale-journal-${j.entry_number}`}>
    <div className="flex justify-between font-medium"><span>{j.entry_number} · {j.reference}</span><span>{j.date} · {j.status}</span></div>
    {j.lines.map((l, i) => (
      <div key={i} className="flex justify-between"><span>{l.account_code} {l.account_name}</span>
        <span>{Number(l.debit || 0).toFixed(2)} / {Number(l.credit || 0).toFixed(2)}</span></div>
    ))}
    <a className="text-info underline" href={`/accounting/journal-entries?search=${encodeURIComponent(j.entry_number)}`} target="_blank" rel="noreferrer">Open journal details</a>
  </div>
);

export const SaleJournalDialog = ({ saleId, onClose }) => {
  const [d, setD] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!saleId) return;
    setD(null);
    api.get(`/sales/${saleId}/journals`).then((r) => setD(r.data)).catch((e) => toast.error(e?.response?.data?.detail || 'Could not load'));
  }, [saleId, tick]);
  return (
    <Dialog open={!!saleId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="sale-journal-dialog">
        <DialogHeader><DialogTitle>Sale accounting & status</DialogTitle></DialogHeader>
        {d && (
          <div className="space-y-2 text-sm">
            <div className="flex flex-wrap gap-2">
              <Badge variant="outline" data-testid="sale-origin">{d.origin === 'pos' ? 'POS — tax invoice issued at payment' : 'Manual / Quick sale'}</Badge>
              {d.invoice && <Badge variant="outline">Invoice {d.invoice.number} · {d.invoice.status}</Badge>}
              <Badge variant="outline" data-testid="sale-zatca-status">ZATCA: {d.zatca_status || 'not reported'}</Badge>
            </div>
            {d.locked_message && <div className="rounded bg-amber-50 border border-amber-200 p-2 text-xs" data-testid="sale-locked-message">{d.locked_message}</div>}
            {d.refund && <SaleRefundPanel refund={d.refund} onDone={() => setTick((t) => t + 1)} />}
            {d.journals.length === 0 && <div className="text-xs text-muted-foreground">No active journal.</div>}
            {d.journals.map((j) => <Je key={j.id} j={j} />)}
            {d.reversals.length > 0 && <div className="text-xs font-medium">Linked reversals</div>}
            {d.reversals.map((j) => <Je key={j.id} j={j} />)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
